var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-6 content",domProps:{"innerHTML":_vm._s(_vm.vacatureText)}}),_c('div',{staticClass:"column"},[_c('carrousel',{attrs:{"page":'meedoen_vacature'}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }